var map = {
	"./E@2x.png": 163,
	"./ENE@2x.png": 164,
	"./ESE@2x.png": 165,
	"./N@2x.png": 166,
	"./NE@2x.png": 167,
	"./NNE@2x.png": 168,
	"./NNW@2x.png": 169,
	"./NW@2x.png": 170,
	"./S@2x.png": 171,
	"./SE@2x.png": 172,
	"./SSE@2x.png": 173,
	"./SSW@2x.png": 174,
	"./SW@2x.png": 175,
	"./W@2x.png": 176,
	"./WNW@2x.png": 177,
	"./WSW@2x.png": 178
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 162;